import React from "react";
import CountrySelect from "../components/countrySelect";
import axios from "axios";
import { useEffect, useState } from "react";

export default function Final() {
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    axios
      .get("https://bkcountdown.com/nodeapp/getFinalCountries")
      .then((res) => {
        setCountries(res.data);
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  let F1_countries = countries.filter((country) => country.match_code == "F1");

  let F2_countries = countries.filter((country) => country.match_code == "F2");
  return (
    <div class="accordion Final" id="accordionExample">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingFour">
          <button
            class="accordion-button "
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseFour"
            aria-expanded="true"
            aria-controls="collapseFour"
          >
            Chung Kết
          </button>
        </h2>
        <div
          id="collapseFour"
          class="accordion-collapse collapse show"
          aria-labelledby="headingFour"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            <div className="countryPredictionContainer">
              <div class="row">
                <div class="col">
                  <CountrySelect
                    group1="A"
                    group2="B"
                    zIndex1="99"
                    zIndex2="98"
                    zIndex3="97"
                    id1="1st"
                    id2="2nd"
                    countries1={F1_countries}
                    countries2={F2_countries}
                  />
                </div>
              </div>
              Mỗi dự đoán đúng = 8 Điểm, Tối đa 8 Điểm
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
